import type { IconSvgObject } from './types';

const LimitationIcon: IconSvgObject = [
  ["path", { d: "M13.5 10.5L18 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "1.5", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 18.999L18.001 21C20.4293 19.1755 22 16.2712 22 13C22 7.47715 17.5228 3 12 3C6.47715 3 2 7.47715 2 13C2 16.2712 3.57069 19.1755 5.99902 21L8 18.999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default LimitationIcon;
